import { COMMENT, VIDEOFEED } from '../enums/TYPES';

export const getCommentDate = (comment: COMMENT): string =>
  comment.authored_at && Date.parse(comment.authored_at) <= Date.parse(comment.created_at)
    ? comment.authored_at
    : comment.created_at;

export const compareCommentsByTime = (left: COMMENT, right: COMMENT): number =>
  Date.parse(getCommentDate(left)) - Date.parse(getCommentDate(right)) || +left.id - +right.id || 0;

export const compareCommentsByTimestamp = (left: COMMENT, right: COMMENT): number =>
  left.timestamp - right.timestamp || compareCommentsByTime(left, right);

export const isDeletedComment = (comment?: { message?: string; deleted_at?: string | null } | null): boolean =>
  !!comment?.deleted_at;

export const getActiveReplies = (comment: COMMENT): COMMENT[] =>
  (comment.replies || []).filter((reply) => reply?.id != null && !isDeletedComment(reply));

export const isVisibleComment = (comment: COMMENT): boolean =>
  comment?.id != null && (!isDeletedComment(comment) || getActiveReplies(comment).length > 0);

export type CommentDrawingFilter = 'all' | 'with' | 'without';

export const matchesCommentDrawingFilter = (comment: COMMENT, filter: CommentDrawingFilter): boolean => {
  if (!isVisibleComment(comment)) return false;
  if (filter === 'all') return true;
  const hasDrawing = (!isDeletedComment(comment) && !!comment.drawing) || getActiveReplies(comment).some((reply) => !!reply.drawing);
  return filter === 'with' ? hasDrawing : !hasDrawing;
};

export const getActiveCommentThreads = (comments: COMMENT[] = []): COMMENT[] =>
  comments.filter((comment) => isVisibleComment(comment)).map((comment) => ({
    ...comment,
    replies: getActiveReplies(comment),
  }));

export const getVisibleFeedComments = <T extends VIDEOFEED>(feed: T): T => ({
  ...feed,
  ...(Array.isArray(feed.comments) && { comments: getActiveCommentThreads(feed.comments) }),
  ...(Array.isArray(feed.topics) && { topics: feed.topics.map((topic) => ({
    ...topic,
    clips: topic.clips?.map((clip) => ({
      ...clip,
      ...(Array.isArray(clip.comments) && { comments: getActiveCommentThreads(clip.comments) }),
    })),
  })) }),
});
